import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import LoginPage from "@/pages/Login";
import HomePage from "@/pages/Home";
import OrdersPage from "@/pages/Orders";
import OrderCard from "@/pages/Orders/OrderCard";
import UsersPage from "@/pages/Users";
import RolesPage from "@/pages/Roles";
import CompaniesPage from "@/pages/Companies";
import ClientsPage from "@/pages/Clients";
import CarriersPage from "@/pages/Carriers";
import DriversPage from "@/pages/Drivers";
import VehiclesPage from "@/pages/Vehicles";
import AuditPage from "@/pages/Audit";
import { ReportPage } from "@/pages/Reports/ReportPage";

// Обёртка для защищённых страниц: ProtectedRoute → AppLayout → <Outlet/>
// рендерится между ними. <Outlet/> подставляет вложенные маршруты.
function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/orders" element={<OrdersPage />} />
            <Route path="/orders/new" element={<OrderCard />} />
            <Route path="/orders/:id" element={<OrderCard />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/roles" element={<RolesPage />} />
            <Route path="/companies" element={<CompaniesPage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/carriers" element={<CarriersPage />} />
            <Route path="/drivers" element={<DriversPage />} />
            <Route path="/vehicles" element={<VehiclesPage />} />
            <Route path="/reports/receivables" element={<ReportPage kind="receivables" />} />
            <Route path="/reports/payables" element={<ReportPage kind="payables" />} />
            <Route path="/audit" element={<AuditPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
